export { loader } from "./_public.tests.products.$name";
import Component from "./_public.tests.products.$name";

export default Component;
